function Button({ onClick, text, loading, color }) {

    return (
        <button
            className={`${color} text-white font-inter py-2 px-4 rounded-sm mt-5 buttonload`}
            onClick={onClick}
        >
            <i className={`${loading}`} /> <span>{text}</span>


        </button>
    );
}

export default Button;